import angular from 'angular';

function dynamicTitle($rootScope, $timeout) {
    return {
        link(scope, el) {
            $rootScope.$on('$stateChangeSuccess', (event, toState) => {
                const title = toState?.data?.pageTitle || 'Talenya';
                $timeout(() => {
                    el.text(title);
                }, 0, false);
            });
        },
    };
}

angular
    .module('TALENYA-FE')
    .directive('dynamicTitle', dynamicTitle);
